import { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { TablePagination, useTheme } from '@mui/material';
import React from 'react';

interface CategoryTablePaginationProps {
  totalCount: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
}

export const CategoryTablePagination: React.FC<
  CategoryTablePaginationProps
> = ({ totalCount, page, rowsPerPage, onPageChange, onRowsPerPageChange }) => {
  const { tokens } = useTheme<LensTheme>();

  return (
    <TablePagination
      component="div"
      count={totalCount}
      page={page - 1}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[25, 50, 100]}
      onPageChange={(_event, newPage) => onPageChange(newPage + 1)}
      onRowsPerPageChange={(event) =>
        onRowsPerPageChange(parseInt(event.target.value, 10))
      }
      labelRowsPerPage="Rows"
      data-testid="category-table-pagination"
      sx={{
        '& .MuiOutlinedInput-notchedOutline': {
          border: `1px solid ${tokens.semantic.color.type.muted.value} !important`,
          borderRadius: '8px',
        },
      }}
    />
  );
};
